import { CTAType } from "@swiggy-private/dls-web-recipe-common-web/dist/components/ReviewItemListCard";

export const UPDATE_GIFTING_CART_API_DEFAULT_ERROR = {
    statusCode: 1,
    statusMessage: "Oops Something went wrong",
    data: null,
};

export const GIFTING_CART_API_DEFAULT_ERROR_MESSAGES = {
    RECEIVED_EMPTY_DATA: "Received empty data from gifting cart details",
    RECEIVED_EMPTY_DATA_FROM_NATIVE: "Received empty data from native",
};

export const STATIC_TEXTS = {
    GIFT_STORE_MULTI_DELIVERY: "Delivery {0} from <b>Gift Store</b>",
    GIFT_STORE_SINGLE_DELIVERY: "Delivery from <b>Gift Store</b>",
    RESTAURANT_MULTI_DELIVERY: "Delivery {0} from <b>{1}</b>",
    RESTAURANT_SINGLE_DELIVERY: "Delivery from <b>{0}</b>",
    ITEM_COUNTER: "{0} item",
    ITEMS_COUNTER: "{0} items",
    MINUTE: "{0} Min",
    MINUTES: "{0} Mins",
    HEADER_OOS: "Currently Unavailable",
    HEADER_UNSERVICEABLE: "Currently Unserviceable",
    REMOVE_ALL: "Remove all",
    OOS: "SOLD OUT",
    RESTRICTED_ITEM_SEPERATOR_NODE_TEXT: "Qty reduced for below item(s) as it’s low in stock.",
    GIFT_STORE_HEADER: "Giftables",
    RESTAURANT: "restaurant",
};

export const CTATypeToText = {
    [CTAType.ADD]: "Add",
    [CTAType.REMOVE]: "Remove",
    [CTAType.OOS]: "SOLD OUT",
    [CTAType.QUANTITY_INC_DEC]: "",
    [CTAType.INCREMENT]: "",
    [CTAType.DECREMENT]: "",
};
